(function () {
  // Makes the discount-progress bar grow into its new value after an AJAX cart
  // update instead of snapping to it.
  //
  // Both cart surfaces refresh by re-rendering the section and replacing whole
  // [data-cart-region] wrappers. That discards the old .progress__fill node, so
  // the incoming one paints at its final width on its first frame and the CSS
  // transition never has two values to interpolate between. The fix is to hand
  // the outgoing width to the incoming node: render it at the OLD width, commit
  // that frame, then set the target so the transition has somewhere to travel.
  //
  // Exposed as a global rather than duplicated in cart-drawer.js and
  // cart-page.js: the two surfaces share the bar's markup and maths (see the
  // cart-progress snippet), and this is the third thing they must agree on.
  window.Allvar = window.Allvar || {};

  // Call with the region element about to be inserted and the one being
  // replaced, BEFORE the swap; then call the returned function right AFTER the
  // swap. Always returns a function, so callers need no null check.
  //
  // Safe to call when either side has no bar — a cart that crosses into or out
  // of having a progress bar just renders at its value with no animation, which
  // is the correct behaviour for an appearing element.
  window.Allvar.carryProgress = function (incoming, outgoing) {
    const noop = function () {};
    if (!incoming || !outgoing) return noop;
    const next = incoming.querySelector('[data-progress-fill]');
    const prev = outgoing.querySelector('[data-progress-fill]');
    if (!next || !prev) return noop;

    const to = next.dataset.progressValue;
    if (to === undefined) return noop;

    // Measure where the outgoing fill actually IS, rather than trusting its
    // data-progress-value. Two quick quantity changes leave the first bar still
    // mid-transition, and rewinding to its *target* would jump the fill backwards
    // before animating forwards again. A percentage of the track keeps the
    // rewind resolution-independent.
    const trackWidth = prev.parentElement ? prev.parentElement.clientWidth : 0;
    if (!trackWidth) return noop;
    const from = (prev.getBoundingClientRect().width / trackWidth) * 100;

    // Nothing to animate when the fill is already at the new value (e.g. a
    // silent refresh triggered by the other surface, or a line edit that
    // doesn't move the subtotal past a rounding boundary). Sub-percent gaps
    // aren't worth a transition.
    if (Math.abs(from - parseFloat(to)) < 0.5) return noop;

    // Rewind the incoming fill to the outgoing width, and arm the transition.
    next.style.setProperty('--progress', from + '%');
    next.classList.add('progress__fill--animate');

    // The caller runs this AFTER inserting the node. Reading offsetWidth forces
    // a synchronous style/layout flush, which commits the rewound width as the
    // element's computed style; assigning the target then has a previous value
    // to interpolate from.
    //
    // Deliberately not requestAnimationFrame: rAF is suspended in background
    // tabs, so a cart updated in a tab the shopper isn't looking at would never
    // run the callback and the bar would stay frozen at the OLD width — a stale
    // bar, worse than the snap this function exists to remove. A forced reflow
    // always runs, in the same task, whatever the tab's visibility.
    return function commit() {
      void next.offsetWidth;
      next.style.setProperty('--progress', to + '%');
    };
  };
})();
